/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { AuthGuard } from '@core/guards/auth/auth.guard';
import { Routes } from '@angular/router';
import { ROUTES_TREE } from '@core/config/routes-tree';
import { RouteCodes } from '@core/config/route-codes';
import { ERRORS } from '@core/models';

export const mainRoutes: Routes = [
  {
    path: ROUTES_TREE[RouteCodes.logon].path,
    loadChildren: () =>
      import('../pages/logon/logon.module').then(m => m.LogonPageModule)
  },
  {
    path: ROUTES_TREE[RouteCodes.register].path,
    loadChildren: () =>
      import('../pages/register/register.module').then(
        m => m.RegisterPageModule
      )
  },
  {
    path: ROUTES_TREE[RouteCodes.activate].path,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../pages/activate/activate.module').then(
        m => m.ActivatePageModule
      )
  },
  {
    path: ROUTES_TREE[RouteCodes.reservedArea].path,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../pages/reserved-area/reserved-area.module').then(
        m => m.ReservedAreaPageModule
      )
  },
  {
    path: ROUTES_TREE[RouteCodes.anonymous].path,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../pages/anonymous/anonymous.module').then(
        m => m.AnonymousPageModule
      )
  },
  {
    path: ROUTES_TREE[RouteCodes.position].path,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../pages/position/position.module').then(
        m => m.PositionPageModule
      )
  },
  {
    path: 'cart',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../pages/cart/cart.module').then(m => m.CartPageModule)
  },
  {
    path: ROUTES_TREE[RouteCodes.settings].path,
    loadChildren: () =>
      import('../pages/settings/settings.module').then(
        m => m.SettingsPageModule
      )
  },
  {
    path: ROUTES_TREE[RouteCodes.error].path,
    loadChildren: () =>
      import('../pages/error/error.module').then(m => m.ErrorPageModule)
  },
  {
    path: ROUTES_TREE[RouteCodes.outOfOrder].path,
    data: { code: ERRORS.outOfOrder },
    loadChildren: () =>
      import('../pages/error/error.module').then(m => m.ErrorPageModule)
  },
  {
    path: ROUTES_TREE[RouteCodes.exit].path,
    loadChildren: () =>
      import('../pages/exit/exit.module').then(m => m.ExitPageModule)
  },
  {
    path: ROUTES_TREE[RouteCodes.dummy].path,
    loadChildren: () =>
      import('../pages/dummy/dummy.module').then(m => m.DummyPageModule)
  },
  {
    path: '',
    redirectTo: 'logon',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'error/404',
    pathMatch: 'full'
  }
];
